import React, { useEffect, useState } from 'react';
import webservice from '../app/webservice/webservice';

// Format an ISO deploy timestamp for display (empty string when absent/invalid).
export const formatDeployTime = (iso) => {
  if (!iso) {
    return '';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
};

// Render one "UI"/"API" build line: the version and (when known) the formatted
// deploy datetime. A plain render helper (not a component) so both lines can
// live in this one file.
const renderVersionLine = (label, version, deployedAt) => {
  const when = formatDeployTime(deployedAt);
  return (
    <span className="app-footer__version">
      <span className="app-footer__version-label">{label}</span>{' '}
      {version || 'unknown'}
      {when ? ` · deployed ${when}` : ''}
    </span>
  );
};

// Shows the deployed UI and API build info (version + deploy datetime) in the
// footer social bar. The UI build info is injected at build time (always
// present); the API build info comes from the public `versionInfo` GraphQL
// query and fails quietly (its line is simply hidden) so the footer always
// renders.
const FooterVersions = () => {
  const [apiBuild, setApiBuild] = useState(null);

  useEffect(() => {
    let alive = true;

    try {
      Promise.resolve(webservice.system.versionInfo())
        .then((info) => {
          if (alive && info) {
            setApiBuild(info);
          }
        })
        .catch(() => {});
    } catch {
      /* webservice unavailable — leave the API line hidden */
    }

    return () => {
      alive = false;
    };
  }, []);

  // UI build/deploy info injected at build time by webpack DefinePlugin
  // (webpack.common.js reads src/static/version.json), so the UI line renders
  // without any runtime fetch. Read here so DefinePlugin inlines the literals.
  const uiVersion = process.env.UI_VERSION || '';
  const uiBuildTime = process.env.UI_BUILD_TIME || '';
  const hasUi = Boolean(uiVersion);
  if (!hasUi && !apiBuild) {
    return null;
  }

  return (
    <div className="app-footer__container app-footer__versions">
      {hasUi ? renderVersionLine('UI', uiVersion, uiBuildTime) : null}
      {apiBuild
        ? renderVersionLine('API', apiBuild.version, apiBuild.deployedAt)
        : null}
    </div>
  );
};

export default FooterVersions;
